import {fileToBase64ObjectNoFileReader} from '@coolcolduk/util';
import {UserSoundType} from '@cp/model';
import {deleteField} from 'firebase/firestore';
import {useCallback} from 'react';
import updateUserDoc from '../../api/user/updateUserDoc';
import uploadUserSoundFile from '../../api/user/uploadUserSoundFile';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export default function useSetSoundFile() {
  const setSoundFileFn = useCallback(async (soundType: UserSoundType, soundFile: File | null): Promise<void> => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) throw new Error('Not authenticated');
    const soundFilePayload = soundFile ? await fileToBase64ObjectNoFileReader(soundFile) : undefined;
    const soundUrl = await uploadUserSoundFile(uid, soundType, soundFilePayload);
    await updateUserDoc(uid, {[soundType.toLowerCase() + 'SoundUrl']: soundUrl ?? deleteField()});
  }, []);

  const {loading, error, refetch} = useFunctionRun(setSoundFileFn, {
    skipLoadOnMount: true,
  });

  return {
    setSoundFile: refetch,
    loading,
    error,
  };
}
